import { render, staticRenderFns } from "./ResultFormSeCwmi.vue?vue&type=template&id=6b7e2ecc&scoped=true&"
import script from "./ResultFormSeCwmi.vue?vue&type=script&lang=js&"
export * from "./ResultFormSeCwmi.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormSeCwmi.vue?vue&type=style&index=0&id=6b7e2ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7e2ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7e2ecc')) {
      api.createRecord('6b7e2ecc', component.options)
    } else {
      api.reload('6b7e2ecc', component.options)
    }
    module.hot.accept("./ResultFormSeCwmi.vue?vue&type=template&id=6b7e2ecc&scoped=true&", function () {
      api.rerender('6b7e2ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ResultFormSeCwmi.vue"
export default component.exports